import script from "./RetailDiscountCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetailDiscountCard.vue?vue&type=script&setup=true&lang=ts"

import "./RetailDiscountCard.vue?vue&type=style&index=0&id=3c1bbe2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1bbe2f"]])

export default __exports__